import { render, staticRenderFns } from "./CardModal.vue?vue&type=template&id=5fbc9566&scoped=true&"
import script from "./CardModal.vue?vue&type=script&lang=js&"
export * from "./CardModal.vue?vue&type=script&lang=js&"
import style0 from "./CardModal.vue?vue&type=style&index=0&id=5fbc9566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc9566",
  null
  
)

export default component.exports